import type { RDKitModule } from "@rdkit/rdkit";

// Use module-scoped augmentation to avoid conflicts with @rdkit/rdkit's own Window declarations
const _win = window as Window & {
  RDKit?: RDKitModule;
  initRDKitModule?: () => Promise<RDKitModule>;
};

const initRDKit = (() => {
  let rdkitLoadingPromise: Promise<RDKitModule> | null = null;

  return (): Promise<RDKitModule> => {
    if (!rdkitLoadingPromise) {
      rdkitLoadingPromise = new Promise<RDKitModule>((resolve, reject) => {
        if (_win.RDKit) {
          resolve(_win.RDKit);
          return;
        }

        if (typeof _win.initRDKitModule !== "function") {
          reject(
            new Error(
              "RDKit script not loaded. Make sure RDKit_minimal.js is included in your HTML.",
            ),
          );
          return;
        }

        _win
          .initRDKitModule()
          .then((rdkit) => {
            const RDKit = rdkit as RDKitModule;
            _win.RDKit = RDKit;
            resolve(RDKit);
          })
          .catch((e: Error) => {
            reject(new Error(`Failed to initialize RDKit: ${e.message || e}`));
          });
      });
    }

    return rdkitLoadingPromise;
  };
})();

export default initRDKit;
